import { render, staticRenderFns } from "./memberRegion.vue?vue&type=template&id=1798d7ee&scoped=true&"
import script from "./memberRegion.vue?vue&type=script&lang=js&"
export * from "./memberRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1798d7ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1798d7ee')) {
      api.createRecord('1798d7ee', component.options)
    } else {
      api.reload('1798d7ee', component.options)
    }
    module.hot.accept("./memberRegion.vue?vue&type=template&id=1798d7ee&scoped=true&", function () {
      api.rerender('1798d7ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberManage/memberRegion.vue"
export default component.exports